import React from 'react';
import SummaryPage from "./SummaryPage.jsx";

const DetailsPage = props => {
  return (<SummaryPage {...props} />);
};

export default DetailsPage;

